// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.chartkit-error {
  display: flex;
  flex-direction: column;
  overflow: auto;
  width: 100%;
  height: 100%;
  padding: 16px;
}
.chartkit-error__title {
  font-size: 13px;
  line-height: 16px;
  margin-bottom: 12px;
}
.chartkit-error__actions {
  margin-bottom: 12px;
}
.chartkit-error__action:not(:first-child) {
  margin-left: 10px;
}
.chartkit-error__request-id {
  color: #999999;
  letter-spacing: 1px;
  font-size: 11px;
}
.chartkit-error__more {
  font-family: "SF Mono", "Menlo", "Monaco", "Consolas", "Ubuntu Mono", "Liberation Mono", "DejaVu Sans Mono", "Courier New", "Courier", monospace;
  overflow: auto;
  white-space: pre-wrap;
  word-wrap: break-word;
  padding: 10px;
  font-size: 13px;
  border-radius: 4px;
  margin-bottom: 12px;
}

.chartkit-error-more__button:before {
  border: none !important;
}
.chartkit-error-more__close-icon {
  width: 16px;
  height: 16px;
}
.chartkit-error-more__close {
  display: inline-flex;
}
.chartkit-error-more__modal-header {
  position: relative;
  padding: 20px 32px 10px;
  line-height: 24px;
  font-size: 19px;
  font-weight: 700;
  display: grid;
  grid-template-columns: auto 16px;
  align-items: center;
}
.chartkit-error-more__modal-body {
  padding: 10px 32px;
  font-size: 13px;
  width: 700px;
}
.chartkit-error-more__modal-footer {
  padding: 28px 32px;
  text-align: right;
}
.chartkit-error-more__modal-request-id {
  margin-bottom: 15px;
}
.chartkit-error-more__modal-request-id-title {
  font-weight: bold;
}
.chartkit-error-more__modal-request-id-value {
  margin: 0 6px;
}
.chartkit-error-more__text {
  padding: 15px;
  font-size: 13px;
  border-radius: 4px;
  background-color: rgba(0, 0, 0, 0.02);
  overflow: auto;
  white-space: pre-wrap;
  word-wrap: break-word;
  font-family: "SF Mono", "Menlo", "Monaco", "Consolas", "Ubuntu Mono", "Liberation Mono", "DejaVu Sans Mono", "Courier New", "Courier", monospace;
}
.chartkit-error-more__text_modal {
  max-height: calc(100vh - 250px);
}
.chartkit-error-more__opened {
  overflow: auto;
  font-size: 14px;
  margin: 0;
  padding-left: 30px;
}
.chartkit-error-more__opened-line {
  cursor: pointer;
}`, "",{"version":3,"sources":["webpack://./src/ui/libs/DatalensChartkit/components/Error/Error.scss","webpack://./src/ui/libs/DatalensChartkit/components/Error/More/More.scss"],"names":[],"mappings":"AAGA;EACI,aAAA;EACA,sBAAA;EACA,cAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;ACFJ;ADII;EACI,eAAA;EACA,iBAAA;EACA,mBAAA;ACFR;ADKI;EACI,mBAAA;ACHR;ADOQ;EACI,iBAAA;ACLZ;ADSI;EACI,cAAA;EACA,mBAAA;EACA,eAAA;ACPR;ADUI;EACI,gJAlCc;EAmCd,cAAA;EACA,qBAAA;EACA,qBAAA;EACA,aAAA;EACA,eAAA;EACA,kBAAA;EACA,mBAAA;ACRR;;AA5BQ;EACI,uBAAA;AA+BZ;AA3BI;EACI,WAAA;EACA,YAAA;AA6BR;AA1BI;EACI,oBAAA;AA4BR;AAxBQ;EACI,kBAAA;EACA,uBAAA;EACA,iBAAA;EACA,eAAA;EACA,gBAAA;EACA,aAAA;EACA,gCAAA;EACA,mBAAA;AA0BZ;AAjBQ;EACI,kBAAA;EACA,eAAA;EACA,YAAA;AAmBZ;AAhBQ;EACI,kBAAA;EACA,iBAAA;AAkBZ;AAfQ;EACI,mBAAA;AAiBZ;AAfY;EACI,iBAAA;AAiBhB;AAdY;EACI,aAAA;AAgBhB;AAXI;EACI,aAAA;EACA,eAAA;EACA,kBAAA;EACA,qCAAA;EACA,cAAA;EACA,qBAAA;EACA,qBAAA;EACA,gJDrEc;ACkFtB;AAXQ;EACI,+BAAA;AAaZ;AATI;EACI,cAAA;EACA,eAAA;EACA,SAAA;EACA,kBAAA;AAWR;AATQ;EACI,eAAA;AAWZ","sourcesContent":[null,".chartkit-error {\n  display: flex;\n  flex-direction: column;\n  overflow: auto;\n  width: 100%;\n  height: 100%;\n  padding: 16px;\n}\n.chartkit-error__title {\n  font-size: 13px;\n  line-height: 16px;\n  margin-bottom: 12px;\n}\n.chartkit-error__actions {\n  margin-bottom: 12px;\n}\n.chartkit-error__action:not(:first-child) {\n  margin-left: 10px;\n}\n.chartkit-error__request-id {\n  color: #999999;\n  letter-spacing: 1px;\n  font-size: 11px;\n}\n.chartkit-error__more {\n  font-family: \"SF Mono\", \"Menlo\", \"Monaco\", \"Consolas\", \"Ubuntu Mono\", \"Liberation Mono\", \"DejaVu Sans Mono\", \"Courier New\", \"Courier\", monospace;\n  overflow: auto;\n  white-space: pre-wrap;\n  word-wrap: break-word;\n  padding: 10px;\n  font-size: 13px;\n  border-radius: 4px;\n  margin-bottom: 12px;\n}\n\n.chartkit-error-more__button:before {\n  border: none !important;\n}\n.chartkit-error-more__close-icon {\n  width: 16px;\n  height: 16px;\n}\n.chartkit-error-more__close {\n  display: inline-flex;\n}\n.chartkit-error-more__modal-header {\n  position: relative;\n  padding: 20px 32px 10px;\n  line-height: 24px;\n  font-size: 19px;\n  font-weight: 700;\n  display: grid;\n  grid-template-columns: auto 16px;\n  align-items: center;\n}\n.chartkit-error-more__modal-body {\n  padding: 10px 32px;\n  font-size: 13px;\n  width: 700px;\n}\n.chartkit-error-more__modal-footer {\n  padding: 28px 32px;\n  text-align: right;\n}\n.chartkit-error-more__modal-request-id {\n  margin-bottom: 15px;\n}\n.chartkit-error-more__modal-request-id-title {\n  font-weight: bold;\n}\n.chartkit-error-more__modal-request-id-value {\n  margin: 0 6px;\n}\n.chartkit-error-more__text {\n  padding: 15px;\n  font-size: 13px;\n  border-radius: 4px;\n  background-color: rgba(0, 0, 0, 0.02);\n  overflow: auto;\n  white-space: pre-wrap;\n  word-wrap: break-word;\n  font-family: \"SF Mono\", \"Menlo\", \"Monaco\", \"Consolas\", \"Ubuntu Mono\", \"Liberation Mono\", \"DejaVu Sans Mono\", \"Courier New\", \"Courier\", monospace;\n}\n.chartkit-error-more__text_modal {\n  max-height: calc(100vh - 250px);\n}\n.chartkit-error-more__opened {\n  overflow: auto;\n  font-size: 14px;\n  margin: 0;\n  padding-left: 30px;\n}\n.chartkit-error-more__opened-line {\n  cursor: pointer;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
